var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.show
    ? _c(
        _setup.Button,
        {
          nativeOn: {
            click: function ($event) {
              return _setup.goToComponentSettings.apply(null, arguments)
            },
          },
        },
        [
          _c("i", { staticClass: "bi-gear-fill me-2" }),
          _vm._v("\n    Settings\n"),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }